<template>
  <div class="main-content">
    <div class="page-header">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">Accounts</li>
        <li class="breadcrumb-item"><router-link :to="{name: 'accounts-users'}">Records</router-link></li>
        <li class="breadcrumb-item active">New user</li>
      </ol>
    </div>
    <div class="card">
      <div class="card-body">
        <h3 class="page-title">New user</h3>
        <form
          v-if="$store.state.permissions.create.accounts_users"
          action="/api/admin/accounts/users/save"
          method="POST"
          autocomplete="off"
          @submit.prevent="saveRecord()"
        >
          <div class="form-group">
            <label>Email</label>
            <input
              v-model.trim="record.email"
              :class="{ 'is-invalid': $v.record.email.$error }"
              class="form-control"
              @input="$v.record.email.$touch()"
            >
            <div v-if="$v.record.email.$error">
              <span
                v-if="!$v.record.email.email"
                class="help-block help-block-error"
              >Correct email is required</span>
              <span
                v-if="!$v.record.email.uniqMail"
                class="help-block help-block-error"
              >Unique email is required</span>
            </div>
          </div>
          <div class="form-group">
            <label for="userRole">Role</label>
            <select id="userRole" v-model="record.main_role" class="form-control">
              <option v-for="(role, idx) in roles" :key="idx" :value="role.id">{{ role.name }}</option>
            </select>
          </div>
          <div class="form-group">
            <label>Password</label>
            <input
              v-model.trim="record.password"
              :class="{ 'is-invalid': $v.record.password.$error }"
              type="password"
              class="form-control"
              autocomplete="new-password"
              placeholder="New password"
              @input="$v.record.password.$touch()"
            >
            <div v-if="$v.record.password.$error">
              <span
                v-if="!$v.record.password.required"
                class="help-block help-block-error"
              >Field is required</span>
              <span
                v-if="!$v.record.password.minLength"
                class="help-block help-block-error"
              >Title must have at least {{ $v.record.password.$params.minLength.min }} letters.</span>
            </div>
          </div>
          <div class="form-group">
            <label>Password (repeat)</label>
            <input
              :class="{ 'is-invalid': $v.record.password_repeat.$error }"
              v-model.trim="record.password_repeat"
              type="password"
              class="form-control"
              placeholder="Repeat new password"
              @input="$v.record.password_repeat.$touch()"
            >
            <label
              v-if="$v.record.password_repeat.$error && !$v.record.password_repeat.sameAsPassword"
              class="error"
              for="name"
            >Passwords must be identical.</label>
          </div>
          <button type="button" class="btn btn-primary" @click="goBack">Back</button>
          <button type="submit" class="btn btn-success">Save</button>
        </form>
        <div v-else class="card">
          <div class="card-header">
            <h3>You have not permission for do that</h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global axios, toastr */
import { required, minLength, email, sameAs } from 'vuelidate/lib/validators'
export default {
  name: 'UsersEdit',
  data () {
    return {
      record: {},
      roles: [],
      emails: []
    }
  },
  validations: {
    record: {
      email: {
        email,
        uniqMail: function (value) {
          return this.emails.indexOf(value) === -1
        }
      },
      password: {
        required,
        minLength: minLength(8)
      },
      password_repeat: {
        sameAsPassword: sameAs('password')
      }
    }
  },
  mounted () {
    axios
      .post('/api/admin/accounts/roles-list')
      .then(response => {
        this.roles = response.data.roles
      })
      .catch(error => {
        let message = (error && error.message) || 'Something goes wrong'
        toastr['error'](message)
      })

    axios
      .post('/api/admin/accounts/emails')
      .then(response => {
        this.emails = response.data.emails
      })
      .catch(error => {
        let message = (error && error.message) || 'Something goes wrong'
        toastr['error'](message)
      })
  },
  methods: {
    saveRecord () {
      let that = this
      this.$v.$touch()
      if (!this.$v.$invalid) {
        axios
          .post('/api/admin/accounts/users/save', {
            user: this.record
          })
          .then(response => {
            if (response && response.data && response.data.result === 'ok') {
              this.record = response.data.user
              this.$nextTick(() => {
                that.$v.$reset()
              })
              toastr['success']('Record has been created successfully')
            } else {
              let message =
                (response && response.data && response.data.message) ||
                'Something goes wrong'
              toastr['error'](message)
            }
          })
          .catch(error => {
            let message = (error && error.message) || 'Something goes wrong'
            toastr['error'](message)
          })
      }
    },
    goBack () {
      this.$router.push('/admin/accounts/users')
    }
  }
}
</script>

<style>
</style>
